(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qwink-offduty-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('qw-repeat-cart'))customElements.define('qw-repeat-cart',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;this.source=document.querySelector('qwink-pad-bundles');if(!this.source)return;this.button=this.querySelector('[data-repeat-add]');this.sync=()=>{const sourceButton=this.source.querySelector('[data-add]');this.querySelector('[data-repeat-summary]').textContent=this.source.querySelector('[data-summary]')?.textContent||'';this.button.disabled=sourceButton?.disabled??true;this.button.textContent=sourceButton?.innerText.replace(/\s+/g,' ').trim()||'Add to cart';this.querySelector('[data-repeat-error]').textContent=this.source.querySelector('[data-error]:not([hidden])')?.textContent||'';};this.observer=new MutationObserver(this.sync);this.observer.observe(this.source,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','hidden']});this.button.addEventListener('click',()=>{const original=this.source.querySelector('[data-add]');if(original&&!original.disabled)original.click();},{signal});this.sync();}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qwink-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('qwink-showcase')){
customElements.define('qwink-showcase',class extends HTMLElement{
connectedCallback(){
this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
this.slides=[...this.querySelectorAll('.qws__slide')];this.index=0;
if(this.classList.contains('qws--catalog')||!this.slides.length)return;
this.querySelectorAll('.qws__controls').forEach(control=>control.hidden=this.slides.length<2);
this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.dataset.direction)this.show(this.index+Number(button.dataset.direction));else if(button.dataset.slide)this.show(this.slides.findIndex(slide=>slide.dataset.block===button.dataset.slide));},options);
this.addEventListener('keydown',event=>{if(event.target.matches('input,textarea,select'))return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}},options);
this.addEventListener('touchstart',event=>{this.start=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;},{...options,passive:true});
this.addEventListener('touchend',event=>{if(!this.start||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-this.start.x,dy=event.changedTouches[0].clientY-this.start.y;this.start=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1));},{...options,passive:true});
document.addEventListener('shopify:block:select',event=>{const index=this.slides.findIndex(slide=>slide.dataset.block===event.detail.blockId);if(index>=0)this.show(index);},options);
this.show(0,false);
}
show(index,announce=true){const focused=this.contains(document.activeElement)?document.activeElement?.dataset?.direction:null;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});this.querySelectorAll('[data-slide]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.slide===this.slides[this.index].dataset.block)));if(focused)this.slides[this.index].querySelector('[data-direction="'+focused+'"]')?.focus({preventScroll:true});if(announce)this.querySelector('.qws__status').textContent=this.slides[this.index].querySelector('h2').textContent;}
disconnectedCallback(){this.controller?.abort();}
});
}

  } catch(e) { console.error(e); }
})();
})();
